import { useFeatureFlags } from '@usap/core'
import getCookieRegex from '../helpers/getCookieRegex'

const useEconomyEnabled = () => {
  const { f39 } = useFeatureFlags()
  if (f39) {
    return f39 === 'b' || f39 === '1' || f39.toString() === 'true'
  }
  return false
}

const useEconomyCookie = () => {
  const { f39 } = useFeatureFlags()
  const f39CookieWindow = getCookieRegex('f39')

  if (f39CookieWindow) {
    return f39CookieWindow
  }

  if (f39) {
    return f39
  }

  return null
}

export { useEconomyEnabled, useEconomyCookie }
